<div class="size-guide-tray">
    <h-tab-list [defaultSelectedTab]="0" [appearance]="'list'" [appeal]="'secondary'" [separatorHeight]="'60%'">
        @if ( content.findYourSize && content.findYourSize.sizeComparisonTable.international?.headers?.length &&
        content.findYourSize.sizeComparisonTable.imperial?.headers?.length ) {
        <h-tab-item>
            <ng-template hTabTitle>
                <div class="tab-title">
                    <h-svg-icon [name]="'find-your-size'" class="svg-style"></h-svg-icon>
                    <span i18n="@@hermes.size_guide.find_your_size.title"> Find your size </span>
                </div>
            </ng-template>

            <ng-container>
                <h-find-your-size [findYourSize]="content.findYourSize"></h-find-your-size>
            </ng-container>
        </h-tab-item>
        } @if (content.measureYourself?.length) {
        <h-tab-item>
            <ng-template hTabTitle>
                <div class="tab-title">
                    <h-svg-icon [name]="'measure-yourself'" class="svg-style"></h-svg-icon>
                    <span i18n="@@hermes.size_guide.measure_yourself.title"> Measure yourself </span></div
                >
            </ng-template>

            <ng-container>
                <h-measure-yourself [measureYourself]="content.measureYourself"></h-measure-yourself>
            </ng-container>
        </h-tab-item>
        }
    </h-tab-list>
</div>
